import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateUserListSearch } from 'Store/lists/actions';

import ListSidebarBox from 'Components/ListSidebarBox/ListSidebarBox';
import InviteTeachersButton from 'Containers/InviteTeachersButton';
import AddStudentButton from 'Containers/AddStudentButton';
import ListFilterInput from 'Containers/ListFilterInput/ListFilterInput';

const UsersListActionBox = props => {
  return (
    <ListSidebarBox>
      {props.listId === 'teachers_in_school' ? (
        <InviteTeachersButton />
      ) : (
        <AddStudentButton {...props} />
      )}
      <ListFilterInput
        listId={props.listId}
        updateFilterCallback={props.updateUserListSearch}
      />
    </ListSidebarBox>
  );
};

UsersListActionBox.propTypes = {
  listId: PropTypes.string.isRequired,
  updateUserListSearch: PropTypes.func.isRequired,
};

export default connect(false, {
  updateUserListSearch,
})(UsersListActionBox);
